import React from 'react'
import { IoMdContact, IoMdLogIn } from "react-icons/io";
import { Link } from 'react-router-dom';
const Header = () => {
  return (
    <>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
  <Link class="navbar-brand" to="/">College management</Link>
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
    <div class="navbar-nav">
      <Link class="nav-item nav-link active" to="/">Home</Link>
      
      <Link class="nav-item nav-link active" to="aboutUs">About us</Link>
      
      <a class="nav-item nav-link active" href="#">Department</a>
      
      <a class="nav-item nav-link active" href="#">Events</a>
      
      <Link class="nav-item nav-link active" to="contactUs"><IoMdContact />Contact us</Link>
      
      <Link class="nav-item nav-link active" to="login"><IoMdLogIn />login</Link>
    </div>
  </div>
</nav>
    </>
      
    
  )
}

export default Header
